export var AssessmentType;
(function (AssessmentType) {
    AssessmentType["Damage"] = "damage";
    AssessmentType["Span"] = "span";
})(AssessmentType || (AssessmentType = {}));
export const AssessmentCommentCreateRequestBodyKeys = [
    'author_name',
    'body',
    'assessment_type',
    'entity_id',
];
export const AssessmentCommentUpdateRequestBodyKeys = ['body'];
